import React from 'react'
import Modal from '../modal/Modal'
import ManageRoles from './ManageRoles/ManageRoles'
import ManageRooms from './ManageRooms/ManageRooms'
import ManageUsers from './ManageUsers/ManageUsers'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setOpenModal } from '../../store/controlPanelSlice'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { toggleCreateRole } from '../../store/userManagement/userManagementSlice'
import CreateRole from './CreateRole/CreateRole'
export default function UserManagement() {

    const dispatch = useDispatch();

    const { t } = useTranslation();

    const { createRoleOpen } = useSelector((state) => state.userManagement);

    const [activeTab, setActiveTab] = useState(0);
    const { localAvatar } = useSelector((state) => state.auth);

    const elementsPerPage = 20;

    const handleCloseCard = () => {
        dispatch(setOpenModal(false));
    }


    return (
        <Modal
            isOpen={true}
            headerIcon={"person_edit"}
            onClose={handleCloseCard}
            size={"xxl"}
            PaperProps={{
                style: {
                    minWidth: '60vw',
                    minHeight: '70vh'
                }
            }}
            header={
                <>
                    {!createRoleOpen &&
                        (<>
                            <div
                                className={`tab ${activeTab === 0 ? "active" : ""}`}
                                onClick={() => setActiveTab(0)}
                            >
                                <span style={{ fontSize: "1.125rem" }}>{t("user_management")}</span>
                            </div>

                            <div
                                className={`tab ${activeTab === 1 ? "active" : ""}`}
                                onClick={() => setActiveTab(1)}
                            >
                                <span style={{ fontSize: "1.125rem" }}>{t("role_management")}</span>
                            </div>

                            <div
                                className={`tab ${activeTab === 2 ? "active" : ""}`}
                                onClick={() => setActiveTab(2)}
                            >
                                <span style={{ fontSize: "1.125rem" }}>{t("room_management")}</span>
                            </div>
                        </>)
                    }

                    <Button
                        sx={{
                            color: "white !important",
                            borderRadius: "0.5rem",
                            background: 'var(--peoplmap-primary)',
                            display: "flex",
                            padding: "0.6875rem 1.375rem",
                            justifyContent: "center",
                            alignItems: "center",
                            textTransform: "none",
                            right: createRoleOpen ? "1.25" : "4.375rem",
                            position: "absolute",

                            '&:hover': {
                                background: "#53c03d",
                            }
                        }}
                        onClick={() => dispatch(toggleCreateRole())}
                    >
                        {!createRoleOpen ? t("create_role") :
                            (<span className="material-symbols-outlined">Close</span>)}
                    </Button>
                </>
            }
        >
            <div>

                <div >
                    {activeTab === 0 && !createRoleOpen &&
                        <ManageUsers
                            key={`tab-users-${activeTab}`}
                            selectedEmployeeAvatar={localAvatar}
                            elementsPerPage={elementsPerPage}
                        />
                    }
                    {activeTab === 1 && !createRoleOpen &&
                        <ManageRoles
                            key={`tab-roles-${activeTab}`}
                            selectedEmployeeAvatar={localAvatar}
                            elementsPerPage={elementsPerPage}
                        />
                    }
                    {activeTab === 2 && !createRoleOpen &&
                        <ManageRooms
                            key={`tab-rooms-${activeTab}`}
                            selectedEmployeeAvatar={localAvatar}
                            elementsPerPage={elementsPerPage}
                        />
                    }
                </div>
                <>
                    {
                        createRoleOpen && <CreateRole
                            onClose={() => dispatch(toggleCreateRole())}
                        />
                    }
                </>
            </div>

        </Modal>
    )
}
